import { EProductEnhancerFieldTypes, IProductEnhancerField } from '../types';

export const MOCK_PRODUCT_ENHANCER_FIELDS: IProductEnhancerField[] = [
  {
    id: 'product_name',
    title: 'Product Name',
    type: EProductEnhancerFieldTypes.TITLE,
    data: 'Southbend 4602DD-3TL Ultimate Restaurant Range Gas 60"'
  },
  {
    id: 'short-description',
    title: 'Short Description',
    type: EProductEnhancerFieldTypes.TEXTAREA,
    data: `Optional 33K Non-clog Burners (Burner Option 1) (10) patented, one piece, lifetime clog free, cast iron burners, 33,000 BTU NAT
    
    Optional Wavy Grates (Burner Option 2), Cast bowl design for better efficiency, Allows full use of entire range top, Available only with 27K BTU Non-clog burners`
  },
  {
    id: 'long-description',
    title: 'Long Description',
    type: EProductEnhancerFieldTypes.TEXTAREA,
    data: `Commercial gas range 60-3/4” wide with a 37” high cooking top, 4” Stainless steel front rail, stainless steel front and sides, Front located manual gas shut-off to entire range, One year No Quibble, 24/7 parts and labor warranty, Factory installed Regulator, Four (4) removable, cast iron grate tops (rear holds up to 14” stock pot), Standing pilot for open top burners, Battery spark ignition for oven bases
    
    Optional 33K Non-clog Burners (Burner Option 1) (10) patented, one piece, lifetime clog free, cast iron burners, 33,000 BTU NAT
    
    Optional Wavy Grates (Burner Option 2), Cast bowl design for better efficiency, Allows full use of entire range top, Available only with 27K BTU Non-clog burners`
  },
  {
    id: 'specifications',
    title: 'Specifications',
    type: EProductEnhancerFieldTypes.LABEL_VALUE,
    data: [
      {
        label: 'Manufacturer',
        value: 'Anwaliya Internationals'
      },
      { label: 'Colour', value: 'Black' },
      { label: 'Country of Origin', value: 'China' }
    ]
  },
  {
    id: 'keywords',
    title: 'E-commerce Keywords',
    type: EProductEnhancerFieldTypes.TAG,
    data: []
  }
];
